export enum SurveyActionType {

  // Update
  UpdateSurvey                    = 'UPDATE_SURVEY',
  UpdateSurveyCompleted           = 'UPDATE_SURVEY_COMPLETED',
  UpdateSurveyFailed              = 'UPDATE_SURVEY_FAILED',

  // Load
  LoadSurveys                     = 'LOAD_SURVEYS',
  LoadSurveysCompleted            = 'LOAD_SURVEYS_COMPLETED',
  LoadSurveysFailed               = 'LOAD_SURVEYS_FAILED',

  // Select
  SelectSurvey                    = 'SELECT_SURVEY',
  SelectSurveyCompleted           = 'SELECT_SURVEY_COMPLETED',
  SelectSurveyFailed              = 'SELECT_SURVEY_FAILED',

  // Update Survey Progress
  UpdateSurveyProgress            = 'UPDATE_SURVEY_PROGRESS',
  UpdateSurveyProgressCompleted   = 'UPDATE_SURVEY_PROGRESS_COMPLETED',
  UpdateSurveyProgressFailed      = 'UPDATE_SURVEY_PROGRESS_FAILED',

  // Load Current Survey
  LoadCurrentSurvey               = 'LOAD_CURRENT_SURVEY',
  LoadCurrentSurveyCompleted      = 'LOAD_CURRENT_SURVEY_COMPLETED',
  LoadCurrentSurveyFailed         = 'LOAD_CURRENT_SURVEY_FAILED',

  // Update Current Survey
  UpdateCurrentSurvey             = 'UPDATE_CURRENT_SURVEY',
  UpdateCurrentSurveyCompleted    = 'UPDATE_CURRENT_SURVEY_COMPLETED',
  UpdateCurrentSurveyFailed       = 'UPDATE_CURRENT_SURVEY_FAILED',

  // Reset Current Survey
  ResetCurrentSurvey              = 'RESET_CURRENT_SURVEY',
  ResetCurrentSurveyCompleted     = 'RESET_CURRENT_SURVEY_COMPLETED',
  ResetCurrentSurveyFailed        = 'RESET_CURRENT_SURVEY_FAILED',
}
